import React, {ReactComponentElement} from 'react'
import {connect, MapStateToPropsParam} from 'react-redux'
import {StoreStructure} from './redux/structures'


export function connectWithStore(store, WrappedComponent, mapStateFn?,mapDispatchFn?) {
  const ConnectedWrappedComponent = connect( mapStateFn,mapDispatchFn)(WrappedComponent) as any
  
  return  props => <ConnectedWrappedComponent {...props} store={store} />
}